<template>
  <div>
    <sinvoice-export-by-class />
  </div>
</template>

<script>
import SinvoiceExportByClass from '@/components/sinvoice_viettel/SinvoiceExportByClass.vue'
export default {
  name: 'ExportByClassView',
  components: { SinvoiceExportByClass }
}
</script>

<style scoped>
h2 { margin: 10px 0; }
</style>
